import React from "react";
import { graphql } from "gatsby";

import SectionTitle from "../components/SectionTitle";
import RichTextRenderer from "../components/RichTextRenderer";
import SaleNotice from "../components/SaleNotice";

const SaleDescription: React.FC<{
  sale: Queries.SaleDescriptionSaleFragment;
}> = ({ sale }) => {
  return (
    <div id="description" className="mx-auto mb-16 max-w-[1200px] px-4">
      <SectionTitle>Sale Description</SectionTitle>
      <RichTextRenderer text={sale.description} />
      <div className="clear-both pt-2">
        <hr className="my-6 border-0 border-b border-gray-500" />
        <SaleNotice name={sale.name} />
      </div>
    </div>
  );
};

export const SaleDescriptionFragment = graphql`
  fragment SaleDescriptionSale on ContentfulSale {
    name
    description {
      raw
      references {
        __typename
        ... on ContentfulRichImage {
          contentful_id
          caption
          positionPreference
          image {
            gatsbyImageData(width: 400)
          }
        }
      }
    }
  }
`;

export default SaleDescription;
